import { useRef, useCallback } from "react";

// https://www.ag-grid.com/react-data-grid/fine-tuning/
/** Use with ag-grid to avoid stale closures inside functions passed to the grid */
export function useDynamicCallback<T extends (...args: any[]) => any>(callback: T): T {
  const ref = useRef(callback);
  ref.current = callback;
  return useCallback((...args: unknown[]) => ref.current.apply(null, args), []) as T;
}
